import React from 'react';
import './contentImage.css'
import { isMobile } from 'react-device-detect';


export const ContentImage = () => {

  return (

    <div className={ isMobile? 'ImageBox-mobile' : 'ImageBox' } >
    
    </div>

    
  )
}

export default ContentImage;